import React from 'react';
import ReactDOM from 'react-dom';
import { setupAxios } from './config/axios';
setupAxios();

import Listings from './listings/Listings';
import Calculator from './calculator/Calculator';
import StorageCalculator from './calculator/StorageCalculator';

function mountListingsComponent() {
    const listingsElement = document.getElementById('listings');

    if (listingsElement) {
        ReactDOM.render(<Listings />, listingsElement);
    }
}

// Try to mount immediately
mountListingsComponent();

// Also try when DOM is ready, in case the element wasn't available yet
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountListingsComponent);
} else {
    // DOM is already ready, try again in case we missed it
    setTimeout(mountListingsComponent, 100);
}

if (document.getElementById('calculator')) {
	ReactDOM.render(<Calculator />, document.getElementById('calculator'));
}
if (document.getElementById('storage-calculator')) {
	ReactDOM.render(<StorageCalculator />, document.getElementById('storage-calculator'));
}

// Share listing functionality
function initShareButtons() {
    // Handle share button clicks (both icon-only and link variants)
    document.querySelectorAll('.btn-share-listing, .btn-share-listing-link').forEach(button => {
        button.addEventListener('click', async function(e) {
            e.preventDefault();
            const url = this.dataset.shareUrl;
            const title = this.dataset.shareTitle;
            
            // Try Web Share API first (mobile/supported browsers)
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: title,
                        text: `Check out this storage space: ${title}`,
                        url: url
                    });
                    return;
                } catch (err) {
                    // User cancelled or share failed, fall through to clipboard
                    if (err.name !== 'AbortError') {
                        console.log('Share failed, falling back to clipboard:', err);
                    } else {
                        return; // User cancelled, don't show clipboard message
                    }
                }
            }
            
            // Fallback to clipboard copy
            try {
                await navigator.clipboard.writeText(url);
                
                // Show success feedback using alert since swal may not be loaded on public pages
                alert('Link copied to clipboard!');
            } catch (err) {
                console.error('Failed to copy to clipboard:', err);
                // Final fallback - show the URL in a prompt
                prompt('Copy this link:', url);
            }
        });
    });
}

// Initialize share buttons when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareButtons);
} else {
    initShareButtons();
}
